import { NgModule } from "@angular/core";

import { LorenLoginRoutingModule } from "./loren-login-routing.module";
import { Login } from "./components/loren-login/login";

@NgModule({
  imports: [
    Login,
    LorenLoginRoutingModule,
  ],
})
export class LorenLoginModule {
}
